var _excluded = ["overflow", "overflowX", "className"],
  _excluded2 = ["className"],
  _excluded3 = ["placement"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className"],
  _excluded7 = ["className", "isNumeric"],
  _excluded8 = ["className"],
  _excluded9 = ["className", "isNumeric"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { tqc, forwardRef, omitThemingProps, StylesProvider, useMultiStyleConfig, useStyles } from '../../../system';
import { useThemedValueSwitch } from '../../../pp2';
import { cx, __DEV__ } from '../../../utils';
import * as React from 'react';
export var TableContainer = forwardRef((props, ref) => {
  var _ref;
  var {
      overflow,
      overflowX,
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(tqc.div, _extends({
    ref: ref,
    className: cx('chakra-table__container', className)
  }, rest, {
    __css: {
      display: 'block',
      whiteSpace: 'nowrap',
      WebkitOverflowScrolling: 'touch',
      overflowX: (_ref = overflow !== null && overflow !== void 0 ? overflow : overflowX) !== null && _ref !== void 0 ? _ref : 'auto',
      overflowY: 'hidden',
      maxWidth: '100%'
    }
  }));
});
export var Table = forwardRef((props, ref) => {
  var styles = useMultiStyleConfig('Table', props);
  var _omitThemingProps = omitThemingProps(props),
    {
      className
    } = _omitThemingProps,
    tableProps = _objectWithoutProperties(_omitThemingProps, _excluded2);
  var {
    isTQ
  } = useThemedValueSwitch();
  return /*#__PURE__*/React.createElement(StylesProvider, {
    value: styles
  }, /*#__PURE__*/React.createElement(tqc.table, _extends({
    role: "table",
    ref: ref,
    __css: styles.table,
    className: isTQ ? '' : cx('chakra-table', className)
  }, tableProps)));
});
if (__DEV__) {
  Table.displayName = 'Table';
}
export var TableCaption = forwardRef((props, ref) => {
  var {
      placement = 'bottom'
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(tqc.caption, _extends({}, rest, {
    ref: ref,
    __css: _objectSpread(_objectSpread({}, styles.caption), {}, {
      captionSide: placement
    })
  }));
});
if (__DEV__) {
  TableCaption.displayName = 'TableCaption';
}
export var Thead = forwardRef((_ref2, ref) => {
  var {
      className
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded4);
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(tqc.thead, _extends({
    className: cx('tqc-thead', className)
  }, rest, {
    ref: ref,
    __css: styles.thead
  }));
});
export var Tbody = forwardRef((_ref3, ref) => {
  var {
      className
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded5);
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(tqc.tbody, _extends({
    className: cx('tqc-tbody', className)
  }, rest, {
    ref: ref,
    __css: styles.tbody
  }));
});
export var Tfoot = forwardRef((_ref4, ref) => {
  var {
      className
    } = _ref4,
    rest = _objectWithoutProperties(_ref4, _excluded6);
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(tqc.tfoot, _extends({
    className: cx('tqc-tfoot', className)
  }, rest, {
    ref: ref,
    __css: styles.tfoot
  }));
});
export var Th = forwardRef((_ref5, ref) => {
  var {
      className,
      isNumeric
    } = _ref5,
    rest = _objectWithoutProperties(_ref5, _excluded7);
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(tqc.th, _extends({
    className: cx('tqc-th', className)
  }, rest, {
    ref: ref,
    __css: styles.th,
    "data-is-numeric": isNumeric
  }));
});
export var Tr = forwardRef((_ref6, ref) => {
  var {
      className
    } = _ref6,
    rest = _objectWithoutProperties(_ref6, _excluded8);
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(tqc.tr, _extends({
    className: cx('tqc-tr', className),
    role: "row"
  }, rest, {
    ref: ref,
    __css: styles.tr
  }));
});
export var Td = forwardRef((_ref7, ref) => {
  var {
      className,
      isNumeric
    } = _ref7,
    rest = _objectWithoutProperties(_ref7, _excluded9);
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(tqc.td, _extends({
    className: cx('tqc-td', className),
    role: "gridcell"
  }, rest, {
    ref: ref,
    __css: styles.td,
    "data-is-numeric": isNumeric
  }));
});